import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoanRequestMessageComponent } from 'src/app/MessageClipboard/loan-request-message/loan-request-message.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { CompanyAccess } from 'src/model/companyAccess.model';
import { LoanRequest } from 'src/model/loanRequest.model';
import { LoanRequestService } from 'src/services/loan-request.service';
import { AuthorizeLoanRequestComponent } from '../authorize-loan-request/authorize-loan-request.component';
import { ReviewLoanRequestComponent } from '../review-loan-request/review-loan-request.component';

@Component({
    selector: 'app-all-loan-request-card',
    templateUrl: './all-loan-request-card.component.html',
    styleUrls: ['./all-loan-request-card.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class AllLoanRequestCardComponent implements OnInit {
  protected sharedService = inject(SharedService);
  private router = inject(Router);
  protected enums = inject(Enums);
  private datePipe = inject(DatePipe);
  private loanRequestService = inject(LoanRequestService);


  @Input() request: LoanRequest;
  @Input() adminAccess: CompanyAccess[];
  @Input() disallowProcess = false;
  @Input() clashedTickets: LoanRequest[];

  isEPFDateMismatch = false;

  ngOnInit(): void {
    if (this.request != undefined && this.request.LoanInfo.Scheme == 'EPF')
      this.isEPFDateMismatch = this.checkIsEPFDateAndTermMismatch(new Date(this.request.UpdatedOn), new Date(this.request.EPFDate), this.request.LoanInfo.Term);
  }

  calculateSettlement(request: LoanRequest) {
    const settlement = request.LoanInfo.Principal + (request.LoanInfo.Term *
      request.LoanInfo.Principal * (request.LoanInfo.InterestRate / 100)) +
      request.LoanInfo.SettlementCharges.Stamp + request.LoanInfo.SettlementCharges.ServiceCharge + request.LoanInfo.SettlementCharges.Extras + (request.LoanInfo.SettlementCharges.HandlingCharge ?? 0);
    return settlement;
  }

  calculateRatio(request: LoanRequest) {
    const settlement = this.calculateSettlement(request)

    const ratio = (settlement / request.EpfAmount) * 100;
    return ratio;
  }

  goToCustomer() {
    this.router.navigate(['/manageCustomer', this.request.CustomerId, this.request.ProfileId]);
  }

  openReviewLoanRequestModal() {
    const modalRef = this.sharedService.openModal(ReviewLoanRequestComponent, 'largeModal');
    modalRef.componentInstance.requestList = [this.request];
    modalRef.componentInstance.loanGroupId = this.request.LoanGroupId;
    modalRef.componentInstance.disallowProcess = this.disallowProcess;
    modalRef.componentInstance.clashedTickets = this.clashedTickets;
  }

  openAuthorizeLoanRequestModal() {
    const modalRef = this.sharedService.openModal(AuthorizeLoanRequestComponent, 'largeModal');
    modalRef.componentInstance.request = this.request;
  }

  async openSendWhatsapp() {
    const requestList = await this.checkOtherLoanRequests();
    const modalRef = this.sharedService.openModal(LoanRequestMessageComponent);
    modalRef.componentInstance.requestList = requestList;
    modalRef.componentInstance.isEPFRequest = requestList[0].LoanInfo.Scheme == 'EPF';
    modalRef.componentInstance.loanGroupId = this.request.LoanGroupId;
    // modalRef.componentInstance.previousEPFLoanList = this.previousEPFLoanList;
  }

  async checkOtherLoanRequests(): Promise<LoanRequest[]> {
    let req: LoanRequest[] = [this.request];
    try {
      if (this.request.LoanGroupId != undefined)
        req = await this.loanRequestService.getLoanGroupApprovalRequests(this.request.LoanGroupId);
    } finally {
      return req;
    }
  }

  constructVerifiedMessage(request: LoanRequest) {
    const verifiedBy = (request.VerifiedBy == undefined) ? "-" : request.VerifiedBy;
    return verifiedBy + " | " + this.datePipe.transform(new Date(this.request.VerifiedOn), "dd-MM-yyyy hh:mm:ss");
  }

  checkIsEPFDateAndTermMismatch(updatedOn: Date, epfDate: Date, loanTerm: number) {
    const dateBasedOnLoanTerm = this.datePipe.transform(new Date(updatedOn.getFullYear(), updatedOn.getMonth() + loanTerm, 1), "dd-MM-yyyy");
    const compareEPFMonth = this.datePipe.transform(new Date(epfDate.getFullYear(), epfDate.getMonth(), 1), "dd-MM-yyyy");

    if (dateBasedOnLoanTerm != compareEPFMonth)
      return true
    else
      return false;
  }
}
